<script setup lang="ts">

import BoxJson from '@/assets/lotties/delivery-box-close.json'
import BoxJsonOpen from '@/assets/lotties/delivery-box-open.json'
import { computed, nextTick, ref, watch } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import type { MysteryBoxReward } from '@/types/shared/player-config'
import { useConfetti } from '@/composables/game/confetti'

const props = defineProps<{
  reward: MysteryBoxReward[] | null
}>()

const emit = defineEmits<{
  (e: 'finish'): void
}>()

const { showConfetti } = useConfetti()

const rewardItem = computed(() => props.reward)
const isOpen = ref(false)

function initAnimation() {
  nextTick(() => {
    setTimeout(() => isOpen.value = true, 1500)
  })
}

watch([isOpen, rewardItem], ([isOpen, rewardItem]) => {
  if (isOpen && !!rewardItem) {
    setTimeout(() => showConfetti({ spread: 220, count: 90 }), 300)
    setTimeout(() => {
      emit('finish')
    }, 850)
  }
})
</script>

<template>
  <div class="fixed inset-0 z-[1000] flex items-center justify-center bg-black/20 backdrop-blur-sm">
    <Transition
      name="fade"
    >
      <Vue3Lottie
        v-if="!isOpen || !reward"
        class="size-[700px] scale-in"
        :animation-data="BoxJson"
        :auto-play="true"
        :loop="true"
        :speed="1.2"
        @on-animation-loaded="initAnimation"
      />
    </Transition>
    <Transition name="fade-slow">
      <Vue3Lottie
        v-if="isOpen && !!reward"
        class="absolute top-1/2 left-1/2 translate-x-[calc(-50%+6px)] -translate-y-1/2 size-[700px]"
        :animation-data="BoxJsonOpen"
        :auto-play="true"
        :loop="true"
        @on-animation-loaded="initAnimation"
      />
    </Transition>
  </div>
</template>

<style scoped lang="scss">
.fade-slow-enter-active {
  transition: opacity 0.5s ease 0.2s; /* 0.2s delay for entering */
}

.fade-slow-leave-active {
  transition: opacity 0.5s ease; /* No delay for leaving */
}

.fade-slow-enter-from,
.fade-slow-leave-to {
  opacity: 0;
}

.fade-slow-enter-to,
.fade-slow-leave-from {
  opacity: 1;
}
</style>